"use client";
import React, { useEffect, useRef } from "react";

interface DisconnectConfirmDialogProps {
	onConfirm: () => Promise<void>;
	onCancel: () => void;
	isLoading?: boolean;
}

export const DisconnectConfirmDialog: React.FC<
	DisconnectConfirmDialogProps
> = ({ onConfirm, onCancel, isLoading = false }) => {
	const dialogRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		dialogRef.current?.focus();
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === "Escape" && !isLoading) {
				onCancel();
			}
		};
		document.addEventListener("keydown", onKeyDown);
		return () => {
			document.removeEventListener("keydown", onKeyDown);
		};
	}, [onCancel, isLoading]);

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
			<div
				ref={dialogRef}
				role="dialog"
				aria-modal="true"
				aria-labelledby="disconnect-wallet-title"
				tabIndex={-1}
				className="bg-[#373132] p-6 rounded-2xl shadow-xl w-full max-w-md"
			>
				<h3 id="disconnect-wallet-title" className="text-xl font-bold mb-4 text-[#FFF1E9]">
					Disconnect Wallet
				</h3>
				<p className="text-[#918884] mb-6">
					Are you sure you want to disconnect your wallet?
				</p>
				<div className="flex justify-end gap-4">
					<button
						onClick={onCancel}
						className="px-4 py-2 rounded-lg bg-[#231F20] text-[#FFF1E9]"
					>
						Cancel
					</button>
					<button
						onClick={onConfirm}
						disabled={isLoading}
						className="px-4 py-2 rounded-lg bg-[#E05E5C] text-white flex items-center justify-center disabled:opacity-50"
					>
						{isLoading ? (
							<div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
						) : null}
						<span>Disconnect</span>
					</button>
				</div>
			</div>
		</div>
	);
};
